import { useState } from "react";
import { usePaymentMethods } from "@/lib/paymentMethods";

const formatEur = (v) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(v) || 0);
const formatQty = (q) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 3 }).format(Number(q) || 0);
const formatDate = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString("fr-FR") : "-");

const linesOf = (c) => (c.items?.length ? c.items : [{ product_name: c.product_name, unit_price: c.client_price, quantity: 1 }]);

/** Contenu complet d'un contrat : 1er produit + pastille « +N », infobulle au survol (bureau), dépliage au toucher (mobile). */
export const ContractSummaryCell = ({ contract, testid }) => {
  const [open, setOpen] = useState(false);
  const pm = usePaymentMethods();
  const lines = linesOf(contract);
  const total = lines.reduce((s, l) => s + (Number(l.quantity) || 0) * (Number(l.unit_price) || 0), 0);
  const rest = lines.length - 1;
  const mode = pm.label(contract.payment_method_code || contract.payment_mode) || "-";
  const detail = (
    <>
      {lines.map((l, i) => (
        <div key={i} className="flex justify-between gap-4" data-testid={`${testid}-line-${i}`}>
          <span className="truncate">{l.product_name || "-"}</span>
          <span className="whitespace-nowrap tabular-nums">{formatQty(l.quantity)} × {formatEur(l.unit_price)} = {formatEur((Number(l.quantity) || 0) * (Number(l.unit_price) || 0))}</span>
        </div>
      ))}
      <div className="flex justify-between gap-4 border-t border-slate-200 mt-1 pt-1 font-semibold">
        <span>Total HT</span><span className="tabular-nums">{formatEur(total)}</span>
      </div>
      <div className="text-slate-500 mt-0.5">{contract.subscription_mode || "-"} · {mode} · {formatDate(contract.next_billing_date || contract.date)}</div>
    </>
  );
  return (
    <div className="relative group/contract" data-testid={testid}>
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="truncate">{lines[0]?.product_name || "-"}</span>
        {rest > 0 && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setOpen(v => !v); }}
            className="shrink-0 rounded-full bg-slate-200 text-slate-600 text-[10px] font-semibold px-1.5 leading-4"
            data-testid={`${testid}-more`}
          >
            +{rest}
          </button>
        )}
      </div>
      <div
        role="tooltip"
        className="pointer-events-none absolute left-0 top-full z-40 mt-1 hidden min-w-[22rem] rounded-md border border-slate-200 bg-white p-2.5 text-[11px] font-normal text-slate-700 shadow-xl md:group-hover/contract:block"
        data-testid={`${testid}-tooltip`}
      >
        {detail}
      </div>
      {open && <div className="md:hidden mt-1.5 rounded-md bg-slate-50 p-2 text-[11px] text-slate-700" data-testid={`${testid}-expanded`}>{detail}</div>}
    </div>
  );
};
